import React, { Component } from 'react';
import './projects.css';
import {Link} from 'react-router-dom';



class ProThumb extends Component {
    constructor(){
        super();
        this.state = {
            data:[]
        }

    };


    componentDidMount(){

    }

  

   

    render() {
    const {item} = this.props;
    const {i} = this.props;
    const {mapActive} =this.props;
    const {win} = this.props;
    const {mPos} = this.props;
    const {mScale} = this.props;
    const {cx} = this.props;
    const {cy} = this.props;
    const {hover} = this.props;
    const {image } = this.props;
    const {initPro} = this.props;
    const { count } = this.props;
    const {secondary} = this.props;
    const {filter} = this.props;
    return (
        
    
      <React.Fragment>
          
          <div key={`item-${item.id}-${this.props.filter}`} className={`${secondary && (filter !=="music")?"secPos":""} mapItem ratio${item.ratio} ${hover===i?"hover":""}`} style={{left: (secondary?(`${item.secx*(win[0]*mScale)/100}px`):(`${item.posx*(win[0]*mScale)/100}px`)), top: (secondary?(`${item.secy*(win[0]*mScale)/100}px`):(`${item.posy*(win[0]*mScale)/100}px`)), zIndex:item.order}}>
                    <div className="fullWidth fullHeight thumbHold"  style={{transform:`translate3d(${cx*count*.09}px,${cy*count*.09}px,0)`}}>
                    <Link to={`/work/${item.slug}`} onClick={initPro.bind(this)}>
                    <div className={`ratH ratio${item.ratio}`}></div>
                    {item.media.length?(
                        item.vidThumb?(
                            item.webm.map((pic,p)=>{
                                return(
                                       
                                        <div key={`pic-${p}`} onMouseOut={(this.props.deCrawl.bind(this))} onMouseOver={(this.props.initCrawl.bind(this))} data-item="1" data-id={i} data-info={`${item.title}${item.client?(` ————— ${item.client}`):('')}`} className={`bgCover viewImgHold fullWidth fullHeight ${(p > 0)?"subImg":''}  ${hover===i?"hover":""}`} style={{backgroundImage: ((this.props.isMobile)?(`url('${this.props.getImg(item.media[0].name, 900)}')`):(''))}}>
                                            <video id={`thumbvid-${i}${p}`} className="imgCover" autoPlay loop playsInline muted preload="auto">
                                                <source src={pic.url} type="video/webm"/>
                                                {item.mp4.length?(
                                                    <source src={item.mp4[0].url} type="video/mp4"/>
                                                ):('')}
                                                
                                            </video>
                                        </div>
                                        
                                
                                )
                            })
                        ):(
                            // item.media.map((pic,p)=>{
                            //     return(
                            //             <div onMouseOut={(this.props.deCrawl.bind(this))} onMouseOver={(this.props.initCrawl.bind(this))} data-item={item.media.length} data-id={i} data-info={`${item.title} ————— ${item.client}`} className={`viewImgHold fullWidth fullHeight ${(p > 0)?"subImg":''}  ${hover===i?"hover":""} ${image===p?"active":""}`}>
                            //                 <img id={`thumb-${i}${p}`} className="imgCover" src={this.props.getImg(pic.name, 800)}></img>
                            //             </div>
                                
                            //     )
                            // })
                            <div id={`thumb-${i}`} onMouseOut={(this.props.deCrawl.bind(this))} onMouseOver={(this.props.initCrawl.bind(this))} data-item={item.media.length} data-id={i} data-info={`${item.title}${item.client?(` ————— ${item.client}`):('')}`} className={`viewImgHold fullWidth fullHeight`} >
                            <img  key={(parseInt(hover)===parseInt(i) && ((parseInt(count) > 1)))?(`thumb-${i}+${image}`):(`thumb-${i}+${0}`)} className="imgCover" src={((parseInt(hover)===parseInt(i)) && image)?(this.props.getImg(item.media[image].name, 800)):(this.props.getImg(item.media[0].name, 800))} alt={`Still from "${this.props.titleCase(item.title)}", ${item.client?("for "+(this.props.titleCase(item.client))):('')} Directed by David M. Helman`}></img>
                            
                           </div>
                        )
                        
                    ):('')}
                    </Link>
                </div>
            </div>

                

    
       </React.Fragment>
    
    );
  }
}

export default ProThumb;



// WEBPACK FOOTER //
// ./src/components/projects/proThumb.js